import React, { Component, createRef, forwardRef, useImperativeHandle } from "react";
import { View, Image, TextInput, Text, FlatList, ActivityIndicator} from "react-native-web";
import { ParallaxProvider, ParallaxBanner, Parallax } from 'react-scroll-parallax';
import { AnimatePresence, motion, useScroll, useTransform, useMotionValue } from 'framer-motion';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import i18n from "../../../i18n";

import Hls from 'hls.js';

const viewportWidth =  window.innerWidth;
const viewportHeight = window.innerHeight;

let titleFontSize30, titleFontSize25, titleFontSize22, titleFontSize20, titleFontSize19, titleFontSize18, titleFontSize17, titleFontSize16, titleFontSize15, titleFontSize14, titleFontSize13, titleFontSize;

if (viewportWidth > 1400)
{
   titleFontSize = 40;
   titleFontSize30 = 30;
   titleFontSize25 = 25;
   titleFontSize22 = 22;
   titleFontSize20 = 20;
   titleFontSize19 = 19;
   titleFontSize18 = 18;
   titleFontSize17 = 17;
   titleFontSize16 = 16;
   titleFontSize15 = 15;
   titleFontSize14 = 14;
   titleFontSize13 = 13;
}
else if (viewportWidth > 1200)
{
   titleFontSize = 35;
   titleFontSize30 = 26;
   titleFontSize25 = 22;
   titleFontSize22 = 20;
   titleFontSize20 = 19;
   titleFontSize19 = 18;
   titleFontSize18 = 17;
   titleFontSize17 = 16;
   titleFontSize16 = 15;
   titleFontSize15 = 14;
   titleFontSize14 = 13;
   titleFontSize13 = 12;
}
else
{
   titleFontSize = 30;
   titleFontSize30 = 24;
   titleFontSize25 = 19;
   titleFontSize22 = 17;
   titleFontSize20 = 18;
   titleFontSize19 = 17;
   titleFontSize18 = 16;
   titleFontSize17 = 15;
   titleFontSize16 = 14;
   titleFontSize15 = 13;
   titleFontSize14 = 12;
   titleFontSize13 = 11;
}

function replaceWithBr(s) {

  return s.replace(/\n/g, "<br />")
        .replace(/\*\*\*(.*?)\*\*\*/g, '<b><i>$1</i></b>')
        .replace(/\*\*(.*?)\*\*/g, '<i>$1</i>')
        .replace(/\*(.*?)\*/g, '<b>$1</b>')
        .replace(/\b(https?:\/\/\S+|www\.\S+)\b/g, (match) => {
            // Check if the link starts with "www." and does not include a protocol
            if (match.startsWith('www.')) {
              return `<a href="http://${match}" target="_blank">${match}</a>`;
            } else {
              return `<a href="${match}" target="_blank">${match}</a>`;
            }
        })
}

function parseAbout(nameone,nametwo) {
     let texte;
     if (nameone !== "")
     {
        texte = nameone;
      }
      else if (nametwo !== "")
      {
         texte = nametwo;
      }
      else
      {
         texte = ""
      }
      // Liste des voyelles (y compris "Y")
      const voyelles = ['A', 'E', 'I', 'O', 'U', 'Y'];

      // Convertir le texte en majuscules pour la comparaison insensible à la casse
      const texteMajuscules = texte.toUpperCase();

      // Vérifier si le premier caractère est une voyelle
      if (texte === "")
      {
        return ``;
      }
      else if (voyelles.includes(texteMajuscules.charAt(0))) {
        return ` d'${texte}`;
      } else {
        return ` de ${texte}`;
      }
}



class PopVideo extends Component {
  constructor(props) {
    super(props);
    this.popupRef = createRef();

    this.videoRef = React.createRef();

    this.state = {
      poster: '',
      url: '',
      showPlayButton: false,
      processing: false,
      showInnerDiv: false,
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }



/*  componentDidUpdate(prevProps, prevState) {
    if (!prevState.showVideo && this.state.showVideo && this.videoRef.current) {

      this.loadVideo();
    }
  }*/

  handleClickOutside = (event) => {
    if (this.popupRef.current && !this.popupRef.current.contains(event.target)) {
      this.closePopup(); // Call the function to close the popup
    }
  }

  closePopup() {
    this.setState({
      showInnerDiv: false
    });

    setTimeout(() => {
      this.props.onClose();
    }, 400);

  }

  displayInnerDiv(poster, url) {
    this.setState({
      poster: poster,
      url: url,
      showInnerDiv: true
    });

    setTimeout(() => {
      this.loadVideo();
    }, 200);
    setTimeout(() => {
      this.handlePlay();
    }, 1000);
  }


  handlePlay = () => {

   if (this.videoRef.current)
   {

     this.videoRef.current.play();
     this.setState({ showPlayButton: false });
   }
   else
   {
     //this.openPopupVunavail();

   }
 }




  async loadVideo () {
     try {
       // 🔥 Directly load from your dynamic route — no axios call needed!

     //  alert(this.props.url);

       const masterUrl = this.state.url;

     // alert('>>> Using dynamic master URL >>> ' + masterUrl);

       if (Hls.isSupported()) {
         //console.log('>>> HLS case 01');
         const hls = new Hls();
         hls.loadSource(masterUrl);
         hls.attachMedia(this.videoRef.current);

         hls.on(Hls.Events.ERROR, function (event, data) {
            //alert('🔥 HLS error:', data);
         });

         hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
           //console.log('Available levels:', hls.levels);

           // Let's say you want to force 720p
           const targetHeight = 1080;

           const levelIndex = hls.levels.findIndex(level => level.height === targetHeight);

           //alert(levelIndex)

           if (levelIndex !== -1) {
             hls.currentLevel = levelIndex;
             hls.autoLevelEnabled = false; // prevent automatic switching
           } else {
             //console.warn('Desired resolution not found in available levels');
           }
        });


       } else if (this.videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
         //console.log('>>> HLS case 02');
         this.videoRef.current.src = masterUrl;
       }

       // Attach play event listener
       const handlePlayEvent = () => {
         //alert('▶️ Play button triggered');
         this.setState({ showPlayButton: false });
       };

       const handlePauseEvent = () => {
         //alert('▶️ Play button triggered');
         this.setState({ showPlayButton: true });
       };

       const handleEndedEvent = () => {
         //alert('▶️ Play button triggered');
         this.closePopup();
       };

       this.videoRef.current.addEventListener('play', handlePlayEvent);
       this.videoRef.current.addEventListener('pause', handlePauseEvent);
       this.videoRef.current.addEventListener('ended', handleEndedEvent);

       // Cleanup
       return () => {
         this.videoRef.current.removeEventListener('play', handlePlayEvent);
         this.videoRef.current.removeEventListener('pause', handlePauseEvent);
         this.videoRef.current.removeEventListener('ended', handleEndedEvent);
       };


     } catch (err) {
       //console.error('Failed to load video:', err);
     }
   }





  render() {
    return (
      <div style={{position: 'fixed', zIndex: 99, width: '100%', height: '100%', top: 0, left: 0, bottom: 0, display: 'flex',
                               justifyContent: 'center', alignItems: 'center',backgroundColor: 'rgba(0,0,0,0.7)'}}>



            {!isMobileOnly && !isTablet &&

              <div className="scroll-area"
                       style={{
                         width: '100%',
                         maxHeight: "100vh",
                         overflowY: "auto",
                         position: "relative",
                         zIndex: 0,
                       }}
                     >

                 <div style={{width: '100%', minHeight: viewportHeight+'px', overflow: 'hidden'}}>

                      <AnimatePresence>

                          {this.state.showInnerDiv && (

                              <motion.div ref={this.popupRef}
                                     initial={{ scale: 0, opacity: 0 }}
                                     exit={{ scale: 0, opacity: 0 }}
                                     whileInView={{ scale: 1, opacity: 1 }}
                                     transition={{ duration: 0.4, ease: 'easeOut' }}
                                     style={{position: 'relative',
                                           width: viewportHeight*0.8*16/9+'px',
                                           height: viewportHeight*0.8+'px',
                                           margin: 'auto', marginTop: (viewportHeight*0.2/2)+'px',
                                           backgroundColor: 'white',
                                           borderRadius: '10px',}}>

                                     <div onClick={this.closePopup.bind(this)} style={{position: 'absolute', cursor: 'pointer', right: 10, top: 10, zIndex: 3}}>
                                        <img src={'/img/cancel_icon_grey.png'} style={{width: '40px', height: '40px'}}/>
                                     </div>


                                    {this.state.showPlayButton &&
                                      <div onClick={this.handlePlay.bind(this)} style={{cursor: 'pointer', position: 'absolute', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1, width: '100px',  height: '100px', borderRadius: '50%', border: '1px solid #777',  top: '50%', left: '50%', padding: 0, marginLeft: '-50px', marginTop: '-50px'}}>
                                         <img src="/img/play_icon_gradient.png" style={{width: '100px',  height: '100px', padding: 0, margin: 0}}/>
                                     </div>
                                   }


                                      <div style={{width: viewportHeight*0.8*16/9+'px', height: viewportHeight*0.8+'px',}}>

                                            <video ref={this.videoRef} controls poster={this.state.poster} playsinline={true}
                                                   style={{width: viewportHeight*0.8*16/9+'px', height: viewportHeight*0.8+'px', borderRadius: '10px', }} />


                                      </div>

                               </motion.div>
                           )}

                       </AnimatePresence>

                    </div>

                </div>
              }




              {isMobileOnly &&

                <div className="scroll-area"
                         style={{
                           width: '100%',
                           maxHeight: "100vh",
                           overflowY: "auto",
                           position: "relative",
                           zIndex: 0,
                         }}
                       >

                   <div style={{width: '100%', minHeight: viewportHeight+'px', overflow: 'hidden'}}>

                        <AnimatePresence>

                              {viewportWidth < viewportHeight && this.state.showInnerDiv && (

                                  <motion.div ref={this.popupRef}
                                         initial={{ scale: 0, opacity: 0 }}
                                         exit={{ scale: 0, opacity: 0 }}
                                         whileInView={{ scale: 1, opacity: 1 }}
                                         transition={{ duration: 0.4, ease: 'easeOut' }}
                                         style={{position: 'relative',
                                               width: viewportWidth*0.9+'px',
                                               height: viewportWidth*0.9*9/16+'px',
                                               margin: 'auto', marginTop: (viewportHeight-(viewportWidth*0.9*9/16))/2+'px',
                                               backgroundColor: 'white',
                                               borderRadius: '10px',}}>

                                         <div onClick={this.closePopup.bind(this)} style={{position: 'absolute', cursor: 'pointer', right: 10, top: 10, zIndex: 3}}>
                                            <img src={'/img/cancel_icon_grey.png'} style={{width: '40px', height: '40px'}}/>
                                         </div>


                                        {this.state.showPlayButton &&
                                          <div onClick={this.handlePlay.bind(this)} style={{cursor: 'pointer', position: 'absolute', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1, width: '60px',  height: '60px', borderRadius: '50%', border: '1px solid #777',  top: '50%', left: '50%', padding: 0, marginLeft: '-30px', marginTop: '-30px'}}>
                                             <img src="/img/play_icon_gradient.png" style={{width: '60px',  height: '60px', padding: 0, margin: 0}}/>
                                         </div>
                                       }


                                          <div style={{width: viewportWidth*0.9+'px', height: viewportWidth*0.9*9/16+'px',}}>

                                                <video ref={this.videoRef} controls poster={this.state.poster} playsinline={true}
                                                       style={{width: viewportWidth*0.9+'px', height: viewportWidth*0.9*9/16+'px', borderRadius: '10px', }} />


                                          </div>

                                   </motion.div>
                               )}


                               {viewportWidth >= viewportHeight && this.state.showInnerDiv && (

                                   <motion.div ref={this.popupRef}
                                          initial={{ scale: 0, opacity: 0 }}
                                          exit={{ scale: 0, opacity: 0 }}
                                          whileInView={{ scale: 1, opacity: 1 }}
                                          transition={{ duration: 0.4, ease: 'easeOut' }}
                                          style={{position: 'relative',
                                                width: viewportHeight*0.7*16/9+'px',
                                                height: viewportHeight*0.7+'px',
                                                margin: 'auto', marginTop: (viewportHeight*0.3/2)+'px',
                                                backgroundColor: 'white',
                                                borderRadius: '10px',}}>

                                          <div onClick={this.closePopup.bind(this)} style={{position: 'absolute', cursor: 'pointer', right: 10, top: 10, zIndex: 3}}>
                                             <img src={'/img/cancel_icon_grey.png'} style={{width: '40px', height: '40px'}}/>
                                          </div>


                                         {this.state.showPlayButton &&
                                           <div onClick={this.handlePlay.bind(this)} style={{cursor: 'pointer', position: 'absolute', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1, width: '60px',  height: '60px', borderRadius: '50%', border: '1px solid #777',  top: '50%', left: '50%', padding: 0, marginLeft: '-30px', marginTop: '-30px'}}>
                                              <img src="/img/play_icon_gradient.png" style={{width: '60px',  height: '60px', padding: 0, margin: 0}}/>
                                          </div>
                                        }


                                           <div style={{width: viewportHeight*0.7*16/9+'px', height: viewportHeight*0.7+'px',}}>

                                                 <video ref={this.videoRef} controls poster={this.state.poster} playsinline={true}
                                                        style={{width: viewportHeight*0.7*16/9+'px', height: viewportHeight*0.7+'px', borderRadius: '10px', }} />


                                           </div>

                                    </motion.div>
                                )}

                         </AnimatePresence>

                      </div>

                  </div>
                }



              {isTablet &&

                <div className="scroll-area"
                         style={{
                           width: '100%',
                           maxHeight: "100vh",
                           overflowY: "auto",
                           position: "relative",
                           zIndex: 0,
                         }}
                       >

                   <div style={{width: '100%', minHeight: viewportHeight+'px', overflow: 'hidden'}}>

                        <AnimatePresence>

                              {viewportWidth < viewportHeight && this.state.showInnerDiv && (

                                  <motion.div ref={this.popupRef}
                                         initial={{ scale: 0, opacity: 0 }}
                                         exit={{ scale: 0, opacity: 0 }}
                                         whileInView={{ scale: 1, opacity: 1 }}
                                         transition={{ duration: 0.4, ease: 'easeOut' }}
                                         style={{position: 'relative',
                                               width: viewportWidth*0.9+'px',
                                               height: viewportWidth*0.9*9/16+'px',
                                               margin: 'auto', marginTop: (viewportHeight-(viewportWidth*0.9*9/16))/2+'px',
                                               backgroundColor: 'white',
                                               borderRadius: '10px',}}>

                                         <div onClick={this.closePopup.bind(this)} style={{position: 'absolute', cursor: 'pointer', right: 10, top: 10, zIndex: 3}}>
                                            <img src={'/img/cancel_icon_grey.png'} style={{width: '40px', height: '40px'}}/>
                                         </div>


                                        {this.state.showPlayButton &&
                                          <div onClick={this.handlePlay.bind(this)} style={{cursor: 'pointer', position: 'absolute', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1, width: '100px',  height: '100px', borderRadius: '50%', border: '1px solid #777',  top: '50%', left: '50%', padding: 0, marginLeft: '-50px', marginTop: '-50px'}}>
                                             <img src="/img/play_icon_gradient.png" style={{width: '100px',  height: '100px', padding: 0, margin: 0}}/>
                                         </div>
                                       }


                                          <div style={{width: viewportWidth*0.9+'px', height: viewportWidth*0.9*9/16+'px',}}>

                                                <video ref={this.videoRef} controls poster={this.state.poster} playsinline={true}
                                                       style={{width: viewportWidth*0.9+'px', height: viewportWidth*0.9*9/16+'px', borderRadius: '10px', }} />


                                          </div>

                                   </motion.div>
                               )}


                               {viewportWidth >= viewportHeight && this.state.showInnerDiv && (

                                   <motion.div ref={this.popupRef}
                                          initial={{ scale: 0, opacity: 0 }}
                                          exit={{ scale: 0, opacity: 0 }}
                                          whileInView={{ scale: 1, opacity: 1 }}
                                          transition={{ duration: 0.4, ease: 'easeOut' }}
                                          style={{position: 'relative',
                                                width: viewportHeight*0.7*16/9+'px',
                                                height: viewportHeight*0.7+'px',
                                                margin: 'auto', marginTop: (viewportHeight*0.3/2)+'px',
                                                backgroundColor: 'white',
                                                borderRadius: '10px',}}>

                                          <div onClick={this.closePopup.bind(this)} style={{position: 'absolute', cursor: 'pointer', right: 10, top: 10, zIndex: 3}}>
                                             <img src={'/img/cancel_icon_grey.png'} style={{width: '40px', height: '40px'}}/>
                                          </div>


                                         {this.state.showPlayButton &&
                                           <div onClick={this.handlePlay.bind(this)} style={{cursor: 'pointer', position: 'absolute', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1, width: '100px',  height: '100px', borderRadius: '50%', border: '1px solid #777',  top: '50%', left: '50%', padding: 0, marginLeft: '-50px', marginTop: '-50px'}}>
                                              <img src="/img/play_icon_gradient.png" style={{width: '100px',  height: '100px', padding: 0, margin: 0}}/>
                                          </div>
                                        }


                                           <div style={{width: viewportHeight*0.7*16/9+'px', height: viewportHeight*0.7+'px',}}>

                                                 <video ref={this.videoRef} controls poster={this.state.poster} playsinline={true}
                                                        style={{width: viewportHeight*0.7*16/9+'px', height: viewportHeight*0.7+'px', borderRadius: '10px', }} />


                                           </div>

                                    </motion.div>
                                )}

                         </AnimatePresence>

                      </div>

                  </div>
                }

       </div>
    );
  }
}

export default PopVideo;
